// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"d9ba0908","33":"e8980f8f","243":"4a8e8786","664":"65166558"}[chunkId] + ".chunk.js";
};